// AppointmentForm.jsx
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export default function AppointmentForm() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_uusknan',
        'template_zbfegom',
        form.current,
        'U3I-mFfvkUs_epjHx'
      )
      .then(
        () => {
          alert('Message sent successfully!');
          form.current.reset();
        },
        () => {
          alert('Failed to send message. Try again later.');
        }
      );
  };

  return (
    <div className="bg-gray-100 p-4 rounded-xl max-w-md w-full mx-auto box-border">
      <h3 className="text-lg font-semibold mb-4 text-center">Get in touch !</h3>

      <form
        ref={form}
        onSubmit={sendEmail}
        className="flex flex-col gap-3 w-full"
      >
        <input
          type="text"
          name="user_name"
          placeholder="Full Name"
          required
          className="w-full p-2 rounded border border-gray-300"
        />
        <input
          type="text"
          name="user_phone"
          placeholder="Phone Number"
          className="w-full p-2 rounded border border-gray-300"
        />
        <input
          type="email"
          name="user_email"
          placeholder="Email"
          required
          className="w-full p-2 rounded border border-gray-300"
        />
        <textarea
          name="message"
          placeholder="What do you need help with?"
          rows={3}
          className="w-full p-2 rounded border border-gray-300"
        />
        <input
          type="text"
          name="preferred_time"
          placeholder="Preferred Date & Time (optional)"
          className="w-full p-2 rounded border border-gray-300"
        />
        <input type="hidden" name="time" value={new Date().toLocaleString()} />

        <button
          type="submit"
          className="
    w-full sm:w-auto
    inline-flex items-center justify-center
    px-6 py-2 sm:px-7 sm:py-2.5   /* ↓ a bit narrower & shorter */
    rounded-lg
    bg-gradient-to-r from-brand to-brand-hover
    text-sm sm:text-sm          /* ↓ text size on mobile */
    text-white font-medium tracking-wide
    shadow-md hover:shadow-lg
    transition
    hover:scale-[1.02] active:scale-95
    focus:outline-none focus-visible:ring-2 focus-visible:ring-brand
  "
        >
          Submit
        </button>

      </form>

      <p className="mt-2 text-xs text-gray-500 text-center">
        I'll get back to you within 24&nbsp;hours to confirm and schedule a call.
      </p>
    </div>
  );
}
